import { useState, useRef, useEffect, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import SelectBox from '../../shared/controls/form/selectBox';
import { DateBox, TextArea, TextBox } from '../../shared/controls/form';
import TruncatedText from '../../shared/component/TruncateText';
import { Button, Modal } from 'rsuite';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import ProductForm from './productForm';
import ChildAccount from '../sharedChild/childAccount';
import apiServices from '../../services/service';
import { useDispatch, useSelector } from 'react-redux';
import { getProductById, getProductList } from '../../redux/selector';
import {
  fetchAccountsAndAppendToModule,
  fetchAccountsAndAppendToProduct,
  fetchAttachmentsAndAppendToModule,
  fetchDetailAndAppendToModule,
  fetchNotesAndAppendToModule,
} from '../../redux/actions';
import Notes from '../sharedChild/note/notes';
import Timeline from '../sharedChild/timeline';
import Email from '../sharedChild/email/emails';
import Attachments from '../sharedChild/attachment/attachments';
import Loader from '../../shared/component/Loader';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';

export const ViewProduct = () => {
  const stateData = useSelector((state) => state);
    let storeLoading = isLoadingByKey(stateData, 'productList');
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(storeLoading);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productID = queryParams.get('id');
  const productList = useSelector(getProductList);
  const dispatch = useDispatch();

  // const productLocalData = useSelector((state) => {
  //   const productId = location.state?.id || productID;
  //   return getProductById(state, productId);
  // });

  const [productLocalData, setProductLocalData] = useState({
    ...(location.state || {}),
    type: 'view',
    from: 'view',
  });
  const productStoreData = useSelector((state) => {
    const productId = location.state?.id || productID; // Use the pre-fetched `leadID`
    return getProductById(state, productId);
  });

  useEffect(() => {
    setProductLocalData((prev) => ({ ...prev, ...productStoreData }));
  }, [productStoreData]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const refs = {
    overview: useRef(null),
    accounts: useRef(null),
    attachments: useRef(null),
    // emails: useRef(null),
    timeline: useRef(null),
  };
  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -250px 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  });

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [imageUrl, setImageUrl] = useState('/assets/images/crm/add-image-placeholder.svg');
  const [formData, setFormData] = useState([]);

  function toTitleCaseFromCamel(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // inserts space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // capitalize the first letter
  }
  const navigate = useNavigate();

  const salesform = () => {
    navigate('/product/viewProduct', {
      state: formData,
    });
  };

  // *******************************************

  // Product‑order columns (NEW)
  const productOrderColDefs = [
    {
      headerName: 'Action',
      field: 'action', // field name can be anything; not in dataset
      width: 80,
      pinned: 'left',
      cellRenderer: (params) => (
        <img
          src="../../assets/images/eye.png"
          alt="View"
          title="View"
          style={{ cursor: 'pointer', width: 11 }} // a bit larger icon
          onClick={() => handleViewRow(params.data)} // <-- use helper
        />
      ),
    },
    { headerName: 'S.No.', field: 'sNo', maxWidth: 70 },
    { headerName: 'Product Name', field: 'productName' },
    { headerName: 'Quantity', field: 'quantity' },
    { headerName: 'Unit Price', field: 'listPrice' },
    { headerName: 'Amount ($)', field: 'amount' },
    { headerName: 'Discount ($)', field: 'discount' },
    { headerName: 'Tax ($)', field: 'tax' },
    { headerName: 'Total ($)', field: 'total' },
    { headerName: 'Status', field: 'status' },
    { headerName: 'Created Date', field: 'createdDate' },
  ];

  const defaultAgColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 120,
  };

  const handleViewRow = (rowData) => {
    console.log('Viewing row:', rowData);
    navigate(`/product/ViewProduct?id=${rowData.salesOrderNumber}`);
  };

  // ****************************************

  // ********************************************

  const handleEditProduct = () => {
    navigate('/products/productList/editProduct', {
      state: formData,
    });
  };
  // ***********************************************

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 20,
    filter: true,
    resizable: true,
    // allow every column to be aggregated
    enableValue: true,
    // allow every column to be grouped
    enableRowGroup: false,
    // allow every column to be pivoted
    enablePivot: true,
    //cellRenderer: supressEdit,
  }));

  // ****************************************

  const [selectedNote, setSelectedNote] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);

  const handlePopupDelete = (note) => {
    setSelectedNote(note); // Store the note to delete
    setDeletePopup(true); // Open the delete confirmation popup
  };

  const handleClickDelete = () => {
    // Perform your delete logic here
    console.log('Deleting note:', selectedNote);

    // TODO: Optionally remove it from state or call an API here

    setDeletePopup(false); // Close the modal after deletion
  };

  const [updateListFlag, setUpdateListFlag] = useState(false);

  const handleCallbackGetList = () => {
    setUpdateListFlag(true);
  };

  // useEffect(() => {
  //   setLoading(true)
  //   const fetchData = async () => {
  //     if (location.pathname.includes("view")) {
  //       try {
  //         const response1 = await apiServices.getProductById(id);
  //         const response2 = await apiServices.getAccountsByProductId(id);

  //         const isAllSuccess =
  //           response1.status === 200

  //         if (isAllSuccess) {
  //           setLoading(false)
  //           setFormData({
  //             ...response1.data?.productDetails,
  //             productAssociations: response2?.data?.productAccountAssociations || [],
  //             type: "view",
  //             from: "view",
  //           });
  //         } else {
  //           setLoading(false)
  //           console.error("One or more API responses failed", {
  //             response1,
  //             response2,
  //           });
  //         }
  //       } catch (error) {
  //         console.error("API call error:", error);
  //       }
  //     }
  //   };
  // setUpdateListFlag(false)
  //   fetchData();
  // }, [location, id, updateListFlag]);

  useEffect(() => {
    const productId = location.state?.id || productID;

    if (location.pathname.includes('view')) {
      setFormData({
        ...productLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (productId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Product',
          id: productId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Product',
          id: productId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Product',
          id: productId,
        })
      );
      dispatch(
        fetchAccountsAndAppendToProduct({
          moduleName: 'Product',
          id: productId,
        })
      );
    }
  }, [location, productLocalData?.id]);

  console.log(productLocalData);

  return (
    <>{loading && <Loader/>}
      <div id="viewProduct">
        <div className="viewPageOuter">
          <div className="viewHeader">
            <HeaderProfileBlock localData={productLocalData} moduleName={'Product'} View={true} />
            <div className="rightAction">
              <button className="btn btn-outline-primary" onClick={handleEditProduct}>
                Edit
              </button>
            </div>
          </div>

          <div className="detailContainer">
            <div className="viewFormContainer">
              <div className="leftBlock">
                <ul>
                  {Object.keys(refs).map((key) => (
                    <li
                      key={key}
                      onClick={() => scrollToSection(key)}
                      style={{ cursor: 'pointer' }}
                      className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                    >
                      <button onClick={() => setActiveTab(key)}>{toTitleCaseFromCamel(key)}</button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rightBlock" id="detailPageRight">
                <div className="addlead_container">
                  <div className="addleadcard1">
                    <div id="overview" className="scrollTo" ref={refs.overview}></div>
                    <ProductForm
                      formData={productLocalData}
                      // handleChange={handleChange}
                      // handleChangeForm={handleChangeForm}
                      // handleSubmit={handleSubmit}
                    />
                  </div>
                  <div className="tab-content">
                    <div id="accounts" className="scrollTo" ref={refs.accounts}></div>
                    <ChildAccount localData={productLocalData} module={'Product'} />
                    <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                    <Attachments localData={productLocalData} module={'Product'} />
                    {/* <div
                          id="emails"
                          className="scrollTo"
                          ref={refs.emails}
                        ></div>
                        <Email localData={productLocalData} module={"Product"} /> */}
                    <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                    <Timeline localData={productLocalData} module={'Product'} />
                  </div>
                </div>
              </div>
            </div>
            <div className="viewFormNotesOuter">
              <div className="ViewFormNotesContainer">
                <Notes leadLocalData={productLocalData} module={'Product'} />
              </div>
            </div>
          </div>
        </div>

        {deletePopup && (
          <Modal show={deletePopup} onHide={() => setDeletePopup(false)} className="modal-delete">
            <Modal.Header closeButton>
              <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this note?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setDeletePopup(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={() => handleClickDelete(selectedNote)}>
                Confirm Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ViewProduct;
